export function normalizeStoryblokSlug(fullSlug) {
    if (typeof fullSlug !== 'string') {
        return ''
    }

    return fullSlug.trim().replace(/^\/+|\/+$/g, '')
}

export function storyblokStoryHref(fullSlug) {
    const slug = normalizeStoryblokSlug(fullSlug)
    return !slug || slug === 'home' ? '/' : `/${slug}`
}

export function normalizeStoryblokRichTextLink(mark) {
    if (mark?.attrs?.linktype !== 'story' || !mark.attrs.href) {
        return mark
    }

    return {
        ...mark,
        attrs: {
            ...mark.attrs,
            href: storyblokStoryHref(mark.attrs.href),
        },
    }
}

export function storyblokLinkHref(link) {
    if (link?.url) {
        return link.url
    }

    if (link?.email) {
        return `mailto:${link.email}`
    }

    if (!link?.cached_url) {
        return link?.anchor ? `#${link.anchor}` : ''
    }

    const path = storyblokStoryHref(link.cached_url)
    return link.anchor ? `${path}#${link.anchor}` : path
}

export function isExternalStoryblokLink(link) {
    return Boolean(link?.url || link?.email)
}
